import { Avatar, Col, Divider, Flex, Row, Space, Button, Card } from "antd";
import { Info } from "components/elements";

import FB from "assets/logo/facebook.png";
import INSTA from "assets/logo/instagram.png";
import INTERNET from "assets/logo/internet.png";
import LINE from "assets/logo/line.png";
import TT from "assets/logo/tiktok.png";
import TWT from "assets/logo/twitter.png";
import { useSelector } from "react-redux";
import styles from "../styles/CompanyProfile.module.css";
import { useTranslation } from "react-i18next";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg"

function address2String(address = {}, lang = "en") {
  const { subDistrict = {}, district = {}, province = {} } = address;
  if (lang === "en") {
    return `${[
      address?.addressEn,
      subDistrict?.subdistrictNameEn,
      district?.districtNameEn,
      province?.provinceNameEn,
    ].join(", ")} ${subDistrict.zipCode}`;
  }
  return `${[
    address?.address,
    subDistrict.subdistrictName,
    district.districtName,
    province.provinceName,
  ].join(", ")} ${subDistrict.zipCode}`;
}

const CompanyProfileView = ({
  currentCompanyProfile = {},
  companyTypeOptions = [],
  onEdit = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  return (
    <Space className={styles.container} size={24} direction="vertical">
      {
        roles.includes("UPDATE_CONFIGURATION|COMPANY_SETTING|COMPANY_PROFILE") &&
        <Row justify="end">
          <Button onClick={onEdit} type="primary"
            style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}
          >
            <Flex align="center" justify="center" gap={8}>
              <EditIcon />
              {t("common.edit").toUpperCase()}
            </Flex>
          </Button>
        </Row>
      }

      <Row justify="center">
        <Avatar
          size={125}
          src={
            currentCompanyProfile.companyLogo
              ? "data:image/png;base64, " + currentCompanyProfile.companyLogo
              : ""
          }
        />
      </Row>
      <Card style={{ border: "solid 1px #EAECF0", borderRadius: "8px" }}>
        <b className={styles.infoTopic}>
          {t("company_profile.label.general_information")}
        </b>
        <Divider />
        <Row gutter={[24, 16]}>
          <Col span={12}>
            <Info
              label={t("company_profile.label.company_name_th")}
              value={currentCompanyProfile.companyName}
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("company_profile.label.company_name_en")}
              value={currentCompanyProfile.companyNameEn}
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("company_profile.label.tax_id")}
              value={currentCompanyProfile.taxId}
            />
          </Col>
          <Col span={12}>
            <Info label={t("company_profile.label.company_type")} value={companyTypeOptions.find(o => o.id == currentCompanyProfile?.companyType?.id)?.["name" + (i18n.language == 'en' ? "En" : "")]} />
          </Col>
          <Col span={12}>
            <Info label={t("company_profile.label.number_of_employees")} value={currentCompanyProfile?.numberOfEmployees} />
          </Col>
          {currentCompanyProfile?.companyType?.code === "COMPANY_TYPE_21" &&
            <Col span={12}>
              <Info label={t("company_profile.label.companyType_description")} value={currentCompanyProfile?.companyTypeDesc} />
            </Col>
          }
        </Row>
      </Card>
      <Card style={{ border: "solid 1px #EAECF0", borderRadius: "8px" }}>
        <b className={styles.infoTopic}>
          {t("company_profile.label.address_information")}
        </b>
        <Divider />
        <Row gutter={[24, 16]}>
          <Col span={24}>
            <Info
              label={t("company_profile.label.address_th")}
              value={address2String(currentCompanyProfile, "th")}
            />
          </Col>
          <Col span={24}>
            <Info
              label={t("company_profile.label.address_en")}
              value={address2String(currentCompanyProfile)}
            />
          </Col>
        </Row>
      </Card>
      <Card style={{ border: "solid 1px #EAECF0", borderRadius: "8px" }}>
        <b className={styles.infoTopic}>
          {t("company_profile.label.contact_information")}
        </b>
        <Divider />
        <Row gutter={[24, 16]}>
          <Col span={12}>
            <Info
              label={t("company_profile.label.tel_no")}
              value={currentCompanyProfile.telNo}
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("company_profile.label.phone_no")}
              value={currentCompanyProfile.phoneNo}
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("company_profile.label.email")}
              value={currentCompanyProfile.email}
            />
          </Col>
          <Col span={12} >
            <Info
              label={t("company_profile.label.fax")}
              value={currentCompanyProfile.faxNo}
            />
          </Col>
        </Row>
      </Card>

      <Card style={{ border: "solid 1px #EAECF0", borderRadius: "8px" }}>
        <b className={styles.infoTopic}>
          {t("company_profile.label.financial_information")}
        </b>
        <Divider />
        <Row gutter={[24, 16]}>
          <Col span={12}>
            <Info
              label={t("company_profile.label.bank_account")}
              value={i18n.language === "en" ? currentCompanyProfile?.bankInformation?.bankAccount?.nameEn : currentCompanyProfile?.bankInformation?.bankAccount?.name || "-"}
            />
          </Col><Col span={12}>
            <Info
              label={t("company_profile.label.bank_account_no")}
              value={currentCompanyProfile?.bankInformation?.bankAccountNo || "-"}
            />
          </Col><Col span={12}>
            <Info
              label={t("company_profile.label.bank_company_code")}
              value={currentCompanyProfile?.bankInformation?.bankreferencecode || "-"}
            />
          </Col><Col span={12}>
            <Info
              label={t("company_profile.label.product_code")}
              value={currentCompanyProfile?.bankInformation?.servicecode || "-"}
            />
          </Col>
        </Row>
      </Card>

      <Card style={{ border: "solid 1px #EAECF0", borderRadius: "8px" }}>
        <b className={styles.infoTopic}>
          {t("company_profile.label.social_media_information")}
        </b>
        <Divider />
        <Row gutter={[24, 16]}>
          <Col span={12} className={styles.socialRow}>
            <div className={styles.socialLogoContainer}>
              <img className={styles.socialLogo} src={FB} alt="Facebook logo" />
            </div>
            <p className={styles.socialInfo}>
              : {currentCompanyProfile.facebook || "-"}
            </p>
          </Col>
          <Col span={12} className={styles.socialRow}>
            <div className={styles.socialLogoContainer}>
              <img className={styles.socialLogo} src={TWT} alt="Twitter logo" />
            </div>
            <p className={styles.socialInfo}>
              : {currentCompanyProfile.x || "-"}
            </p>
          </Col>
          <Col span={12} className={styles.socialRow}>
            <div className={styles.socialLogoContainer}>
              <img
                className={styles.socialLogo}
                src={INSTA}
                alt="Instagram logo"
              />
            </div>
            <p className={styles.socialInfo}>
              : {currentCompanyProfile.instagram || "-"}
            </p>
          </Col>
          <Col span={12} className={styles.socialRow}>
            <div className={styles.socialLogoContainer}>
              <img className={styles.socialLogo} src={TT} alt="Tiktok logo" />
            </div>
            <p className={styles.socialInfo}>
              : {currentCompanyProfile.tiktok || "-"}
            </p>
          </Col>
          <Col span={12} className={styles.socialRow}>
            <div className={styles.socialLogoContainer}>
              <img className={styles.socialLogo} src={LINE} alt="Line logo" />
            </div>
            <p className={styles.socialInfo}>
              : {currentCompanyProfile.lineId || "-"}
            </p>
          </Col>
          <Col span={12} className={styles.socialRow}>
            <div className={styles.socialLogoContainer}>
              <img
                className={styles.socialLogo}
                src={INTERNET}
                alt="Internet logo"
              />
            </div>
            <p className={styles.socialInfo}>
              : {currentCompanyProfile.website || "-"}
            </p>
          </Col>
        </Row>
      </Card>
    </Space>
  );
};

export default CompanyProfileView;
